module.exports = __webpack_public_path__ + "media/images/flags/16/Republic-of-the-Congo-5b9c1e1d96e176ccae157ae50d20bed8.png";